<div class="progress-bar-container">
  <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loader.isLoading$ | async">
  </mat-progress-bar>
</div>
